import * as BaseApi from "../Base.api";

export const getStudentInfo = async (studentId: number) => {
    const url = `/student/popup/student/${studentId}`;
    return await BaseApi.get(url);
};
